import { InjectionToken } from '@angular/core';

export const API_BASE: InjectionToken<string> = new InjectionToken('API_BASE');
